import React from 'react'

import { getTextColorFromBackgroundColor } from 'utils/theme'
import { SpacingTypes, ThemeColor } from 'utils/themes/types'

import { StyledText, StyledView } from './styled'

import { Box, BoxPadding } from '../Box'
import { ButtonSizeTypes } from '../Button'
import { Pressable, PressableProps } from '../Pressable'

interface Props extends PressableProps {
  disabled?: boolean
  title?: string
  type?: ThemeColor
  size?: ButtonSizeTypes
  padding?: SpacingTypes | BoxPadding
  icon?: React.ReactNode | string
  onPress?: () => void
}

export const IconButton = ({
  disabled = false,
  title = undefined,
  type = 'primary',
  size = 'md',
  padding = 'md',
  icon = null,
  ...basePressableProps
}: Props) => {
  const hasTitle = !!title
  const textColor = getTextColorFromBackgroundColor(type)

  return (
    <Pressable {...basePressableProps} disabled={disabled}>
      <StyledView
        padding={padding}
        squared={!title}
        hasTitle={hasTitle}
        disabled={disabled}
        type={type}
        size={size}
      >
        {icon && <Box>{icon}</Box>}
        {title ? (
          <Box flex={1}>
            <StyledText fontSize={size} fontWeight='semiBold' color={textColor}>
              {title}
            </StyledText>
          </Box>
        ) : null}
      </StyledView>
    </Pressable>
  )
}
